module.exports = __webpack_public_path__ + "static/img/4105_phase_function_Paper_Points.d02280c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4105_phase_function_Paper_Points.png
// module id = AG1n
// module chunks = 0